export default function anneeSemaineToString(anneeSemaine, prefixe = '') {
  const semaine = anneeSemaine.toString().substring(4, 6);
  const annee = anneeSemaine.toString().substring(0, 4);
  return prefixe + semaine + ' ' + annee;
}
